/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ProtobufAnyFromJSON, ProtobufAnyToJSON, } from './ProtobufAny';
export function ApiRowFromJSON(json) {
    return ApiRowFromJSONTyped(json, false);
}
export function ApiRowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dimensions': !exists(json, 'dimensions') ? undefined : json['dimensions'],
        'metrics': !exists(json, 'metrics') ? undefined : (json['metrics'].map(ProtobufAnyFromJSON)),
    };
}
export function ApiRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dimensions': value.dimensions,
        'metrics': value.metrics === undefined ? undefined : (value.metrics.map(ProtobufAnyToJSON)),
    };
}
